import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export interface IGetAdminReviewFlagsResponse {
  companyID: string;
  flags: string[];
}

export const getAdminReviewFlags = (axios: IAxiosInstance) => {
  return async () => {
    const response = await axios.noRetry.get<
      ZealApiResponse<IGetAdminReviewFlagsResponse>
    >(`/api/getAdminReviewFlags`);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
